import { Tile } from '@almbrand/tile';

export interface TileComponentProps extends LocalId {
	icon: Icon;
	backgroundColor?: BackgroundColor;
	colorComplexion?: string;
	cssClass?: string;
	contentId: number;
	properties?: ImageProperties;
	title: string;
	url: Link;
	target?: '_self' | '_blank';
	bmetricId?: string;
}

export const TileComponent: React.FC<TileComponentProps> = ({
	icon,
	backgroundColor,
	contentId,
	// properties,
	title,
	url,
	target,
	useReadline,
	readlineId,
	bmetricId,
}) => {
	const rootUrl = window.location.origin;
	const { altText } = icon?.properties ?? {};
	const resolvedId = useReadline && readlineId ? readlineId : contentId;
	const resolvedUrl = url?.url;

	if (process.env.NODE_ENV !== 'production') {
		// eslint-disable-next-line no-console
		console.debug('[TileComponent] render', {
			resolvedId,
			title,
			iconUrl: icon?.url,
			altText,
			resolvedUrl,
			target,
			backgroundClass: backgroundColor?.cssClass,
			bmetricId,
			useReadline,
			readlineId,
			contentId,
		});
	}

	return (
		<Tile
			id={resolvedId}
			className={bmetricId}
			title={title}
			icon={icon?.url}
			altText={altText ?? `Tile Icon ${altText}`}
			url={resolvedUrl}
			target={target}
			backgroundColor={backgroundColor?.cssClass}
			trackingEvent={{
				event: 'trackNavigation',
				navigationAction: title ?? '',
				navigationDestination: `${rootUrl}${resolvedUrl ?? ''}`,
				navigationType: 'tile',
			}}
		/>
	);
};
